import HttpService from '../HttpService'

const _http = new HttpService()
export default {
  save: (payload) => {
    return _http.post('/api/audio-visual/check-list-operator-answer', payload)
  },
}